export default __webpack_public_path__ + "2d8b948cb6b3411402d52eb829f0320b.jpg";